<template>
    <div class="project-list m-no-pad m-span" v-if="ShowProjectList()">

        <!-- Project list -->
        <div class="list single" v-if="mobile">
            <div class="project" v-for="(project, p) in projects.Projects" :key="p">

                <!-- Heading; project type and icon -->
                <div class="flex-y-center heading-project-type" @click="Toggle()" v-if="p === 0">
                    <img class="project-list-icon" :src="IconSource()" :alt="`Icon - ${projects.Type}`" :title="projects.Type" width="75" height="75"/>
                    <span class="heading-type">{{ projects.Type }}</span>
                    <div class="flex-right p-mobile">
                        <img :src="ExpandIndicatorSource().plus" alt="Icon - Plus" title="Plus" width="50" height="50" v-if="!showList"/>
                        <img :src="ExpandIndicatorSource().minus" alt="Icon - Minus" title="Minus" width="50" height="50" v-else/>
                    </div>
                </div>

                <span :class="FilterState(project)" v-if="showList">
                    <div class="btn link" v-if="(ItemRevealIterant(p, project) + 1) <= itemReveal.revealAmount" @click="ViewProject(project)">
                        <span class="project-name">{{ project.Project }}</span>
                        <span id="label-viewing" v-if="project.ProjectID === selectedProject.id">Viewing</span>
                        <div class="m-filter-list">
                            <SearchList :list="FilterList(project)" :searching="searching"/>
                        </div>
                    </div>
                    <div class="btn button-remaining-items" v-if="ShowAdditionalProjectsButton(p)" @click="itemReveal.Reveal(10)">
                        <span>Show <b>{{ itemReveal.initialCount }}</b> more projects</span>
                    </div>
                </span>
            </div>
        </div>
        <div class="list single" v-else>
            <div class="project" v-for="(project, p) in projects.Projects" :key="p">
                <h3 v-if="p === 0">{{ project.Type }}</h3>
                <div class="link">
                    <span class="btn project-name" href="#" v-if="(p + 1) <= itemReveal.revealAmount" @click="ViewProject(project)">{{ project.Project }}</span>
                </div>
                <div class="btn button-remaining-projects" v-if="ShowAdditionalProjectsButton(p)" @click="RevealProjects()">
                    <span>Show <b>{{ itemReveal.initialCount }}</b> more projects</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import router from "@/router";
import {
    ASSETS,
    ItemReveal
} from "@/assets/JS/Assets.js";
import store from "@/store";
import SearchList from "@/components/Projects/CurrentSearch/List.vue";

export default {
    name: "ProjectCategoryList",
    props: {
        projects: Object,
        mobile: Boolean,
        priorityType: String,
        selectedProject: Object,
        searching: Boolean
    },
    components: { SearchList },
    data: () => ({
        showList: false,
        itemReveal: class {}
    }),
    methods: {
        IconSource: function() {
            let source = "";
            switch(this.projects.Type) {
                case "3D":
                    source = "Icon3D.png";
                    break;
                case "Application":
                    source = "IconApplication.png";
                    break;
                case "Design":
                    source = "IconDesign.png";
                    break;
                case "Illustration":
                    source = "IconIllustration.png";
                    break;
                case "Photography":
                    source = "IconPhotography.png";
                    break;
                case "Web":
                    source = "IconWeb.png";
                    break;
            }
            return require(`@/assets/Images/Projects/Types/${source}`);
        },
        ShowAdditionalProjectsButton: function(projectIndex) {
            return projectIndex === this.projects.Projects.length - 1 && this.itemReveal.AdditionalItems();
        },
        ViewProject: function(project) {
            const route = router.getRoutes().filter(r => r.name === "Project")[0];
            const formattedProject = ASSETS.CleanURL(project.Project);
            ASSETS.Projects.View(
                this,
                store,
                project,
                formattedProject,
                project,
                route
            );
        },
        Toggle: function() {
            if (this.mobile) {
                this.showList = !this.showList;
            }
        },
        ExpandIndicatorSource: function() {
            let plus, minus;
            plus = minus = "";
            switch(this.priorityType) {
                case "Focus":
                    plus = "PlusBlue.png";
                    minus = "MinusBlue.png";
                    break;
                case "Archive":
                    plus = "PlusGray.png";
                    minus = "MinusGray.png";
                    break;
            }
            return {
                plus: require(`@/assets/Images/${plus}`),
                minus: require(`@/assets/Images/${minus}`)
            };
        },

        // Handles filtering of projects based on current search filter
        Filtered: function(project) {
            const filtered = [];
            if (project.search) {
                for (const projectType of project.search.types) {
                    const match = project.ProjectTypes.filter(p => p.Name === projectType);
                    if (match.length) {
                        filtered.push(match[0]);
                    }
                }
                return filtered;
            }
            return [];
        },
        FilterState: function(project) {
            let state = "";
            if ((this.searching && this.Filtered(project).length) || !this.searching) {
                state = "";
            } else {
                state = "hide";
            }
            return state;
        },
        FilterList: function(project) {
            const filtered = this.Filtered(project);
            const filters = [];
            for (const filter of filtered) {
                filters.push(`${filter.Name}`);
            }
            return filters;
        },

        ItemRevealIterant: function(nonSearchIterant, project) {
            let searchIterant = project.search ? project.search.filterID : nonSearchIterant;
            return !this.searching ? nonSearchIterant : searchIterant;
        },
        ShowProjectList: function() {
            return !this.searching || (this.searching && this.projects.CategoryFilteredTotal > 0)
        },
        RevealProjects: function() {
            this.itemReveal.revealAmount += 10;
            if (this.Remaining() < this.itemReveal.initialCount) {
                this.itemReveal.initialCount = this.Remaining();
            }
        },
        Remaining: function() {
            const remaining = this.projects.Projects.length - this.itemReveal.revealAmount;
            if (remaining > 0) {
                return remaining;
            }
        }
    },
    beforeMount: function() {
        this.itemReveal = new ItemReveal(this.projects.Projects, 10, 10);
    },
    emits: [ "project" ]
};
</script>